import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import SMSplitViewMixin from 'components/mixins/SMSplitViewMixin';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMConst from 'lib/SMConst';
import SMORoomEditBasicFragment from './fragments/SMORoomEditBasicFragment';
import SMORoomEditDescriptionFragment from './fragments/SMORoomEditDescriptionFragment';
import SMORoomEditMediaFragment from './fragments/SMORoomEditMediaFragment';
import SMORoomEditPlanFragment from './fragments/SMORoomEditPlanFragment';
import SMORoomEditOptionFragment from './fragments/SMORoomEditOptionFragment';
import SMORoomEditMenuView from './SMORoomEditMenuView';
import SMOPlanEditView from './fragments/SMOPlanEditView';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMHistoryHelper from 'components/helpers/SMHistoryHelper';
import reactMixin from 'react-mixin';

class SMORoomEditView extends SMDashboardBaseView {

  constructor(props) {
    super(props);

    this.formRequest = null;
    this.knownFormErrors = [];
    let room_extra_business_hours = null;
    if (
      this.props.room &&
      this.props.room.attributes &&
      this.props.room.attributes.room_extra_business_hours
    ) {
      room_extra_business_hours = this.props.room.attributes.room_extra_business_hours;
    }

    this.state = {
      display: this.props.display,
      selectedRowIndex: 0,
      owner: this.props.owner ? this.props.owner.attributes : null,
      space: this.props.space ? this.props.space.attributes : null,
      room: this.props.room ? this.props.room.attributes : null,
      room_extra_business_hours: room_extra_business_hours,
      errors: []
    };
  }

  componentDidMount() {
    $('body').addClass('js-split-view');
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    $(document).on("SMRoomHandleUpdate", this.handleUpdate.bind(this));
    $(document).on("SMRoomHandleUpdateCheckBox", this.handleUpdateCheckBox.bind(this));
    $(document).on("SMRoomHandleUploadFile", this.handleUploadFile.bind(this));
    $(document).on("SMRoomHandleDestroyHasManyAssociationItems", this.handleDestroyRoomHasManyAssociationItems.bind(this));
    $(document).on("SMRoomHandleUpdateExtraBusinessHours", this.handleUpdateRoomExtraBusinessHours.bind(this));

    this.sizeToFit();
    this.addSplitViewModal(this.refs.formContent);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
    $(document).off("SMRoomHandleUpdate", this.handleUpdate);
    $(document).off("SMRoomHandleUpdateCheckBox", this.handleUpdateCheckBox);
    $(document).off("SMRoomHandleUploadFile", this.handleUploadFile);
    $(document).off("SMRoomHandleDestroyHasManyAssociationItems", this.handleDestroyRoomHasManyAssociationItems);
    $(document).off("SMRoomHandleUpdateExtraBusinessHours", this.handleUpdateRoomExtraBusinessHours);
  }

  componentWillReceiveProps(nextProps) {

  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  componentDidUpdate(prevProps, prevState) {

  }

  postOrUpdateSpace(owner, id, formData, queries, completion) {
    if (this.state.room.id) {
      return SMOwnerResource.updateRoom(owner, id, formData, queries, completion);
    } else {
      return SMOwnerResource.postRoom(owner, formData, queries, completion);
    }
  }

  postOrUpdateWithJsonSpace(owner, id, payload, queries, completion) {
    if (this.state.room.id) {
      return SMOwnerResource.updateRoomWithJson(owner, id, payload, queries, completion);
    } else {
      return SMOwnerResource.postRoom(owner, payload, queries, completion);
    }
  }

  handleUpdateRoomExtraBusinessHours(e, data) {
    let payload = {};
    let newExtraBusinessHours = [];
    let oldExtraBusinessHours = [];
    let dbExtraBusinessHours = [];

    if (this.state.room_extra_business_hours) {
      oldExtraBusinessHours = this.state.room_extra_business_hours;
    }
    if (this.state.room.room_extra_business_hours) {
      dbExtraBusinessHours = this.state.room.room_extra_business_hours;
    }

    I18n.t('date.day_names').forEach(function(item, i) {
      // ローカルの値を取得して、その後ID部分をstateにコピー
      let newExtraBusinessHour = null;
      if (oldExtraBusinessHours) {
        newExtraBusinessHour = oldExtraBusinessHours.find(e => e.weekday == i);
      }

      let dbExtraBusinessHour = null;
      if (dbExtraBusinessHours) {
        dbExtraBusinessHour = dbExtraBusinessHours.find(e => e.weekday == i);
      }

      if (newExtraBusinessHour != null && dbExtraBusinessHour != null) {
        newExtraBusinessHour.id = dbExtraBusinessHour.id;
      }

      // 編集対象の場合
      if (data.weekday == i) {
        if (!newExtraBusinessHour) {
          newExtraBusinessHour = { weekday: data.weekday };
        }

        newExtraBusinessHour._destroy = false;

        switch (data.name) {
          case 'start_hour': {
            newExtraBusinessHour.start_hour = data.value;
            break;
          }
          case 'end_hour': {
            newExtraBusinessHour.end_hour = data.value;
            break;
          }
          case 'toggle': {
            if (data.value == '0') {
              newExtraBusinessHour._destroy = true;
            }
            break;
          }
        }
      }

      if (newExtraBusinessHour) {
        newExtraBusinessHours.push(newExtraBusinessHour);
      }
    });

    payload.room_extra_business_hours = newExtraBusinessHours;
    this.formRequest = this.postOrUpdateWithJsonSpace(
      this.state.owner, this.state.room.id, payload, { space_id: this.state.space.id }, this.responseHandler.bind(this, 'room_extra_business_hours', true)
    );
    // エラーが発生した際に更新内容が失われてしまうためstateに設定し、保持する (Destroyされたものはクリーンする)
    const nextExtraBusinessHours = newExtraBusinessHours.filter(e => e._destroy == null || e._destroy == false);
    this.setState({
      room_extra_business_hours: nextExtraBusinessHours
    });
  }

  handleUpdateCheckBox(e, data) {
    let payload = {},
        propertyName;

    if (data.name.search(/\[\]$/) != -1) {
      propertyName = data.name.replace(/\[\]$/, '');
      payload[propertyName] = data.checked ? [data.value] : [''];

      let items;
      if (propertyName == 'business_days' || propertyName == 'allow_rent_types') {
        items = this.state.room[propertyName].map(function(item) { return { name: item }; });
      } else if (propertyName == 'event_type') {
        items = this.state.room.event_types.map(function(item) { return { name: item.name }; });
      } else {
        items = this.state.room[propertyName];
      }

      items.forEach(function(item, index) {
        if (item.name != data.value) {
          payload[propertyName].push(item.name);
        }
      });

      // 利用形態1日レンタルをチェックした場合、使用用途を全チェック
      if (propertyName == 'allow_rent_types' && data.value == SMConst.RentType.DayTime) {
        payload['event_type'] = [''];
        if (data.checked) {
          this.props.eventTypes.map(
            function(item) {
              payload['event_type'].push(item.attributes.name);
            }
          );
        }
      }

    } else {
      propertyName = data.name;
      payload[data.name] = data.checked;
    }

    // 貸出可能な時間帯を曜日毎に設定するのチェックを外した場合は残っている曜日毎の営業時間設定をクリアする
    if (propertyName == 'has_extra_business_hours' && !data.checked) {
      let destroyExtraBusinessHours = [];
      if (this.state.room.room_extra_business_hours) {
        this.state.room.room_extra_business_hours.forEach((hour) => {
          if (hour.id) {
            destroyExtraBusinessHours.push({id: hour.id, _destroy: true});
          }
        });
        payload['room_extra_business_hours'] = destroyExtraBusinessHours;
      }
      this.setState({room_extra_business_hours: null});
    }

    this.formRequest = this.postOrUpdateWithJsonSpace(
      this.state.owner, this.state.room.id, payload, {space_id: this.state.space.id}, this.responseHandler.bind(this, propertyName, true)
    );
  }

  handleDestroyRoomHasManyAssociationItems(e, data) {
    let payload = {};
    payload[data.name] = { '0':{ id: data.id, _destroy: 'true'}};
    this.formRequest = this.postOrUpdateWithJsonSpace(
      this.state.owner, this.state.room.id, payload, {space_id: this.state.space.id}, this.responseHandler.bind(this, data.name, true)
    );
  }

  handleUploadFile(e, data) {
    let formData = new FormData(),
        propertyName = data.name.replace('[]', ''),
        fileCount = data.files.length;
    for (let i=0; i < fileCount; i++) {
      formData.append(data.name, data.files[i]);
    }

    this.setState(function(previousState, currentProps) {
      for (let i=0; i < fileCount; i++) {
        if (previousState.room[propertyName] && typeof previousState.room[propertyName].push === 'function') {
          previousState.room[propertyName].push({_loading: true});
        }
      }
      return {room: previousState.room};
    });

    this.formRequest = this.postOrUpdateSpace(
      this.state.owner, this.state.room.id, formData, {space_id: this.state.space.id}, this.responseHandler.bind(this, propertyName, true)
    );
  }

  handleUpdate(e, data) {
    this.formRequest = this.postOrUpdateWithJsonSpace(
        this.state.owner, this.state.room.id, data.payload, {space_id: this.state.space.id}, this.responseHandler.bind(this, data.name, true)
      );
  }

  shouldPlanEditViewMount() {
    if (this.state.selectedRowIndex == 3) {
      if (this.state.room.has_session_price) {
        if (!this.state.room.session_price || !this.state.room.min_required_session_hour) {
          return true;
        } else {
          return false;
        }
      } else {
        if (!this.state.room.has_hourly_price && !this.state.room.has_daily_price) {
          return true;
        } else if (this.state.room.has_hourly_price && this.state.room.hourly_price) {
          return false;
        } else if (this.state.room.has_daily_price && this.state.room.daily_price) {
          return false;
        } else {
          return true;
        }
      }
    } else {
      return false;
    }
  }

  actionButtonDidClick(status, e) {
    e.preventDefault();
    let currentTarget = e.currentTarget;
    // if (this.formRequest) this.formRequest.abort();
    if (this.state.room.id) {
      this.postOrUpdateWithJsonSpace(this.state.owner, this.state.room.id, {status: status}, {space_id: this.state.space.id}, function(data, error, xhr){});
    }
    location.href = currentTarget.href;
  }

  nextButtonDidSelect(x) {
    this.setState({selectedRowIndex: this.state.selectedRowIndex + 1});
    $(this.refs.formContent).scrollTop(0);

    setTimeout(()=>{
      if (this.shouldPlanEditViewMount()) {
        this.showDialog(<SMOPlanEditView room={this.state.room} model={this.state.room} delegate={this} errors={this.state.errors} />);
      }
    }, 10);
  }

  sizeToFit(e) {
    let $mainTable = $(this.refs.formContent);

    $mainTable.outerHeight(this.mainTableHeight() - 74);
    this.mainTableFooterSizeToFit();
  }

  tableDidSelectRowAtIndex(rowIndex) {
    this.setState({selectedRowIndex: rowIndex});
    $(this.refs.formContent).scrollTop(0);

    setTimeout(()=>{
      if (this.shouldPlanEditViewMount()) {
        this.showDialog(<SMOPlanEditView room={this.state.room} model={this.state.room} delegate={this} errors={this.state.errors} />);
      } else {
        this.hideDialog();
      }
    }, 10);
  }

  holidayDidClick() {
    this.setState({selectedRowIndex: this.refs.basicFragment.props.fragmentIndex});
    setTimeout(()=>{
      $(this.refs.formContent).scrollTop($(ReactDOM.findDOMNode(this.refs.basicFragment.refs.businessDays)).offset().top);
    }, 10);
  }

  setKnownFormErrors(name, errors) {
    if(!errors) return;

    if (name.search(/^(option_items|option_foods|plans)$/) != -1) {
      let knownFormErrors = [];
      this.knownFormErrors.forEach(function(knownError, index) {
        if (knownError.field.search(name) == -1) {
          knownFormErrors.push(knownError);
        }
      }, this);
      this.knownFormErrors = knownFormErrors;
    }

    errors.forEach(function(error) {
      let existed = false;
      for (let i = 0; i < this.knownFormErrors.length; i++) {
        let knownError = this.knownFormErrors[i];
        if (knownError.field == error.field && knownError.message == error.message) {
          existed = true;
          break;
        }
      }

      if (!existed) {
        this.knownFormErrors.push(error);
      }
    }, this);
  }

  resolveKnownFormErrorOf(name) {
    if (!name) return;

    if (name == 'has_session_price' && !this.state.room.has_session_price) {
      this.knownFormErrors = this.knownFormErrors.filter(function(error) {
        return error.field.search(/^(session_price|min_required_session_hour)$/) == -1;
      });
    }

    this.knownFormErrors = this.knownFormErrors.filter(function(error) {
      return error.field != name && error.field.search('^' + name + '(\.|\/)') == -1;
    });
  }

  // delegate
  responseHandler(name, partial, data, error, xhr) {
    this.formRequest = null;
    // if (error == "abort") return;

    if (xhr.status == 200 || xhr.status == 201) {
      SMHistoryHelper.replaceState(
        Routes.edit_owner_dashboard_space_room_path(
          this.state.owner.username, this.state.space.username, data.uid
        ),
        this.state
      );

      if (partial) {
        this.resolveKnownFormErrorOf(name);
      } else {
        this.knownFormErrors = [];
        let roomJson = data;
      }


      this.setState(function(previousState, currentProps) {
        return {
          room: data,
          errors: this.knownFormErrors,
          selectedRowIndex: (previousState.room.plans.length > data.plans.length) ? previousState.selectedRowIndex - 1
                                                                                  : previousState.selectedRowIndex
        };
      });

      setTimeout(()=>{
        $(this.refs.formContent).showSuccessMessage(I18n.t("dashboard.notice_000001"));
      }, 300);
      $(document).trigger("SMRoomDidUpdateSuccess", [name, null, data]);
    } else if (xhr.status == 400) {
      if (partial) {
        this.setKnownFormErrors(name, xhr.responseJSON.errors);
      } else {
        this.knownFormErrors = xhr.responseJSON.errors;
      }
      this.setState({errors: this.knownFormErrors});

      // if (!partial) $(this.refs.formContent).showFailMessage(I18n.t("dashboard.error_000002"));
      $(document).trigger("SMRoomDidFailToUpdate", [name, null, this.knownFormErrors]);
    } else {
      let errors = xhr.responseJSON.errors;
      $(document).trigger("SMRoomDidFailToUpdate", [name, null, errors]);
    }
  }

  formDidUpdate(e) {
    let name = e.target.name,
        value = e.target.value;
    this.postOrUpdateWithJsonSpace(
      this.state.owner, this.state.room.id, {}, {space_id: this.state.space.id}, this.responseHandler.bind(this, name, true)
    );
  }

  addNewPlanDidSelect() {
    let newPlan = {
      has_hourly_price: true,
      has_daily_price: false,
      has_session_price: false,
      has_min_required_hour: false,
      is_required_food: false,
      has_min_required_food_price: false,
    };
    let planIndex = this.state.room.plans.length;
    this.showDialog(
      <SMOPlanEditView room={this.state.room} model={newPlan} delegate={this} planIndex={planIndex} errors={this.state.errors} />
    );
  }

  planEditDidCompleted(e) {
    e.preventDefault();
    this.hideDialog();
  }

  deletePlan(planId) {
    if(window.confirm(I18n.t("dashboard.notice_000003"))){
      $(document).trigger("SMRoomHandleDestroyHasManyAssociationItems", [{name: 'plans', id: planId}]);
    }
  }

  render() {
    let today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    let rows = [];
    rows.push(<SMORoomEditBasicFragment ref='basicFragment' key='basic' delegate={this} space={this.state.space} room={this.state.room} eventTypes={this.props.eventTypes} amenities={this.props.amenities} fragmentIndex={0} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />);
    rows.push(<SMORoomEditDescriptionFragment ref='descriptionFragment' key='description' delegate={this} space={this.state.space} room={this.state.room} fragmentIndex={1} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />);
    rows.push(<SMORoomEditMediaFragment ref='mediaFragment' key='media' delegate={this} room={this.state.room} fragmentIndex={2} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />);
    rows.push(<SMORoomEditPlanFragment ref='plan0Fragment' key='plan-0' delegate={this} room={this.state.room} plan={this.state.room} planIndex={-1} today={today} fragmentIndex={3} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />);
    if (this.state.room.plans) {
      for (let i=0; i < this.state.room.plans.length; i++) {
        rows.push(<SMORoomEditPlanFragment ref={'plan'+i+'Fragment'} key={'plan-'+this.state.room.plans[i].id} delegate={this} room={this.state.room} plan={this.state.room.plans[i]} planIndex={i} today={today} fragmentIndex={4+i} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />);
      }
    }
    rows.push(<SMORoomEditOptionFragment ref='optionItemFragment' name='option_items' items={this.state.room.option_items} key='option_items' delegate={this} owner={this.state.owner} space={this.state.space} room={this.state.room} fragmentIndex={rows.length} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />);
    if (this.state.room.option_foods.length > 0) {
      rows.push(<SMORoomEditOptionFragment ref='optionFoodFragment' name='option_foods' items={this.state.room.option_foods} key='option_foods' delegate={this} owner={this.state.owner} space={this.state.space} room={this.state.room} fragmentIndex={rows.length} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />);
    }

    return (
      <div className="dashboard-container clearfix mb30">
        <SMORoomEditMenuView delegate={this} owner={this.state.owner} space={this.state.space} room={this.state.room} errors={this.state.errors} selectedRowIndex={this.state.selectedRowIndex} action={this.props.action} />
        <div id="js-split_view-main" ref="formContent" className="dashboard-maincol__right js-scroller">
          {rows}
        </div>
      </div>
    );
  }
}

SMORoomEditView.propTypes = {
  owner: PropTypes.object.isRequired,
  space: PropTypes.object.isRequired,
  room: PropTypes.object.isRequired,
  eventTypes: PropTypes.array.isRequired,
  amenities: PropTypes.array.isRequired,
  action: PropTypes.string.isRequired,
};
reactMixin(SMORoomEditView.prototype, SMSplitViewMixin);
export default SMORoomEditView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/SMORoomEditView.jsx